import type {
    ComposableOptionsBase
} from '~/types';
import {
    SiteMembershipContext
} from '~/types';
import { LookupKeys } from '~/constants';
import { useCustomFetch, useApiUtils } from '~/composables';
import { useKookies } from 'x1-base/composables';
import type { NitroFetchOptions } from 'nitropack';
import type { NuxtError } from '#app';

const { orgIdSessionKey, orgCtxTypeKey } = LookupKeys;

/**
*  @deprecated
*/
export const SiteMembershipCtx = () => useState<SiteMembershipContext>('keySiteMembershipContext', () => SiteMembershipContext.Entity);


export interface UseOrgsOptions extends ComposableOptionsBase {
    contextPrefix?: string;
    initialContext?: Nullable<SiteMembershipContext>;
}
export function useOrgs(options: Partial<UseOrgsOptions> = {}) {
    const apiBasePath = `/v1`;
    const { useReactiveKookie } = useKookies();
    const siteCurrentOrgUid = useReactiveKookie<Nilish<string>>(orgIdSessionKey);
    const SiteMembershipCtxKookie = useReactiveKookie<Nilish<SiteMembershipContext>>(orgCtxTypeKey);


    /**
    *  @deprecated
    */
    const siteMembershipCtx = SiteMembershipCtx();


    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    // Set initial context
    if (options.initialContext) {
        siteMembershipCtx.value = SiteMembershipCtxKookie.value || options.initialContext;
    }

    /**
    *  @deprecated
    */
    function toggleSiteMembershipCtx(membershipCtx?: SiteMembershipContext): SiteMembershipContext {
        const val = siteMembershipCtx.value = membershipCtx ?? (
            siteMembershipCtx.value === SiteMembershipContext.Personal ?
            SiteMembershipContext.Entity : SiteMembershipContext.Personal
        );
        SiteMembershipCtxKookie.value = val;
        return val;
    }

    function setCurrentOrgUid(uid: string = ''): string {
        siteCurrentOrgUid.value = uid || null;
        return uid;
    }

    async function createOnboardingRequest<T extends object>(data: T): Promise<T | NuxtError> {
        const url = `${apiBasePath}/teams/onboarding-requests/`;
        const config: NitroFetchOptions<string> = {
            method: 'POST',
            body: data
        };

        try {
            // TODO: Fix Type
            return await $_fetch<any>(url, config);
        } catch (err) {
            return useApiUtilsObj.getNuxtErrorObj(err);
        }
    }

    return {
        siteMembershipCtx: readonly(siteMembershipCtx),
        siteCurrentOrgUid: readonly(siteCurrentOrgUid),
        toggleSiteMembershipCtx,
        setCurrentOrgUid,
        createOnboardingRequest
    };
}
